import ClientPortalAdminRoutes from './ClientPortalAdminRoutes';

export default ClientPortalAdminRoutes;
